module.exports = __webpack_public_path__ + "img/ico_system_active.00a633f5.svg";